<template>
  <el-card
    v-loading="isloading"
    class="aisevent-look"
    shadow="never"
    :body-style="{ padding: '20px' }"
  >
    <div slot="header" class="clearfix">
      <span style="font-size: 16px">订阅信息</span>

      <span
        v-if="info.code"
        style="font-size: 12px; color: #b3b3b3; margin-left: 15px"
      >
        {{ info.name }} &nbsp; {{ info.nameEn }}({{ info.code }})
      </span>

      <el-button
        type="text"
        size="small"
        style="margin-left: 15px"
        @click="reset"
      >
        刷新
      </el-button>

      <el-button
        type="text"
        size="small"
        :disabled="!available"
        style="margin-left: 15px"
        @click="acquire"
      >
        获取
      </el-button>

      <el-button
        type="text"
        size="small"
        style="margin-left: 15px"
        @click="traceSequence"
      >
        路径数据
      </el-button>
    </div>
    <el-form size="mini" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="MMSI">
            <div class="mmsi-area">
              <el-input
                v-model="form.mmsi"
                :placeholder="info.mmsi"
                clearable
                class="mmsi-input"
              />
              <i class="match-result" :class="matchResult" />
            </div>
            <el-link
              v-if="matchmmsi.mmsi !== null"
              type="danger"
              @click="selectMatchmmsi"
            >
              正确MMSI应该为:
              {{ matchmmsi.mmsi || '空' }}
            </el-link>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="船名">
            <el-input
              :value="info.vessel"
              placeholder="船名"
              style="width: 100%"
            >
              <el-button
                slot="append"
                icon="el-icon-refresh-right"
                :loading="matchmmsi.isloading"
                class="trygetmmsi"
                @click="tryGetMmsi"
              />
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开始时间" prop="btm" style="margin-bottom: 0">
            <el-date-picker
              v-model="form.btm"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
              :clearable="false"
            />
            <span class="relative-time">{{ relativeTime(form.btm) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="结束时间" prop="etm" style="margin-bottom: 0">
            <el-date-picker
              v-model="form.etm"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="空"
              style="width: 100%"
              :clearable="false"
            />
            <span class="relative-time">{{ relativeTime(form.etm) }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="ATA">
            <el-date-picker
              v-model="form.ata"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="空"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="ATD">
            <el-date-picker
              v-model="form.atd"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="空"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="ATB_A">
            <el-date-picker
              v-model="form.atbA"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="空"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="ATB_D">
            <el-date-picker
              v-model="form.atbD"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="空"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="手动控制时间">
            <el-date-picker
              v-model="form.manualExpirationTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="空"
              style="width: 100%"
            />
            <span v-if="form.manualExpirationTime" class="relative-time">{{
              relativeTime(form.manualExpirationTime)
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="text-align: right">
      <span
        v-if="isInCurrentVoyage > 0"
        style="margin-right: 10px; font-size: 12px; color: #e6a23c"
      >
        当前挂靠列表中未找到{{ isInCurrentVoyage }}记录
      </span>
      <el-button
        type="text"
        size="mini"
        :loading="loadrecording"
        title="将开始和结束时间各向外增加一个月"
        @click="loadRecordlist"
      >
        获取记录
      </el-button>
    </div>

    <el-table
      v-loading="loadrecording"
      :data="form.recordlist || []"
      size="mini"
      max-height="280"
      style="margin-top: 10px"
    >
      <el-table-column prop="type" label="类型" width="60">
        <template slot-scope="scope">
          {{ scope.row.type === 'current' ? '当前' : '历史' }}
        </template>
      </el-table-column>
      <el-table-column prop="ata" label="ATA" width="150" />
      <el-table-column prop="atbA" label="ATB_A" width="150" />
      <el-table-column prop="atbD" label="ATB_D" width="150" />
      <el-table-column prop="atd" label="ATD" width="150" />
      <el-table-column prop="portEn" label="港口英文名">
        <template slot-scope="scope">
          <div
            :style="{
              color: info.nameEn === scope.row.portEn ? '#cc00ff' : '#999',
            }"
          >
            {{ scope.row.portEn }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="portCn" label="港口中文名" />
      <el-table-column prop="portCode" label="港口代码">
        <template slot-scope="scope">
          {{ scope.row.portCode }}
          <div
            v-if="scope.row.portCode0"
            style="margin-top: 2px"
            :style="{
              color: info.code === scope.row.portCode0 ? '#cc00ff' : '#999',
            }"
          >
            {{ scope.row.portCode0 }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: right; margin-top: 15px">
      <el-button size="small" @click="$emit('close')">取消</el-button>
      <el-button type="primary" size="small" :loading="saving" @click="save">
        保存
      </el-button>
    </div>
  </el-card>
</template>

<script>
import request from '@/mixins/request'
import dayjs from 'dayjs'

const keys = [
  'mmsi',
  'btm',
  'etm',
  'ata',
  'atd',
  'atbA',
  'atbD',
  'updateCount',
  'code',
  'nameEn',
  'requiredField',
  '_source',
  'recordlist',
  'manualExpirationTime',
]

export default {
  mixins: [request],

  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      form: {
        mmsi: '',
        _source: '',
      },

      isloading: false,

      matchmmsi: {
        mmsi: null,
        isloading: false,
        state: 'error',
      },

      saving: false,

      loadrecording: false,
      isInCurrentVoyage: 0,
    }
  },

  computed: {
    mmsivalid() {
      return /^\d{9}$/.test(this.form.mmsi)
    },

    available() {
      return (
        this.mmsivalid &&
        this.form.btm &&
        this.form.etm &&
        this.form.btm < this.form.etm &&
        this.form.code
      )
    },

    matchResult() {
      if (this.matchmmsi.isloading) {
        return 'el-icon-loading match-result-loading'
      }

      if (this.matchmmsi.state === 'success') {
        return 'el-icon-success match-result-success'
      }

      if (this.matchmmsi.state === 'error') {
        return 'el-icon-error match-result-error'
      }
    },
  },

  watch: {
    info: {
      handler() {
        this.matchmmsi = {
          mmsi: null,
          isloading: false,
        }
        keys.forEach(k => this.$set(this.form, k, ''))
        this.isInCurrentVoyage = 0

        if (this.info.id) {
          this.$nextTick(this.reset)
        }
      },
      immediate: true,
    },
  },

  methods: {
    async traceSequence() {
      this.isloading = true
      try {
        const resp = await this.$api.get('/trace/aiseventops/traceSequence', {
          params: {
            id: this.info.id,
          },
          baseURL: '/',
        })

        if (resp.data.statusCode === 20000) {
          this.$emit('trace-sequence', resp.data.content || {})
        } else if (resp.data.statusCode === 20001) {
          return this.$message.warning('未找到路径数据')
        } else {
          return this.$message.error(resp.data.message || '获取路径数据错误')
        }
      } finally {
        this.isloading = false
      }
    },

    async reset() {
      this.isloading = true
      try {
        const sub = await this.findSubscription(this.info.id)
        if (sub) {
          keys.forEach(k => this.$set(this.form, k, sub[k]))
          await this.tryGetMmsi()
        }
      } finally {
        this.isloading = false
      }
    },

    async acquire() {
      if (!this.available) {
        return
      }

      this.isloading = true
      this.form._source = ''

      try {
        const resp = await this.$api.post(
          '/trace/aiseventops/acquireSubscription',
          {
            mmsi: this.form.mmsi,
            btm: this.form.btm,
            etm: this.form.etm,
            code: this.form.code,
            nameEn: this.form.nameEn,
            requiredField: this.form.requiredField,
          },
          { baseURL: '/' }
        )

        if (resp.data.status === 1) {
          const data = resp.data.content || {}
          ;['ata', 'atd', 'atbA', 'atbD'].forEach(key =>
            this.$set(this.form, key, data[key] || '')
          )

          if (typeof data.updateCount === 'number') {
            if ((data.updateCount & 2) === 2) {
              return this.$message.warning('没有找到ais信息')
            } else {
              if ((data.updateCount & 4) === 4) {
                this.form._source = 'current'
              } else if ((data.updateCount & 4) === 8) {
                this.form._source = 'history'
              }
            }
          }
        } else {
          return this.$message.error(resp.data.message || '获取ais信息错误')
        }
      } finally {
        this.isloading = false
      }
    },

    async findSubscription(id) {
      this.isloading = true
      try {
        const resp = await this.$api.post('/trace/aiseventops/refresh', [id], {
          baseURL: '/',
        })
        if (resp.data.status === 1) {
          const data = (resp.data.content || [])[0] || {}
          if (data.mmsi === 0) {
            data.mmsi = ''
          }
          return data
        } else {
          this.$message.error(resp.data.message || '获取订阅信息错误')
        }
      } finally {
        this.isloading = false
      }
    },

    async tryGetMmsi() {
      this.matchmmsi = {
        mmsi: null,
        state: 'error',
        isloading: true,
      }
      try {
        const resp = await this.$api.get('/trace/aiseventops/tryGetMmsi', {
          params: {
            vessel: this.info.vessel || '',
            carrier: this.info.carrier || '',
          },

          baseURL: '/',
        })

        if (resp.data.status === 1) {
          const mmsi = resp.data.content || ''
          if (mmsi !== this.form.mmsi) {
            this.matchmmsi.mmsi = mmsi
            this.matchmmsi.state = 'error'
          } else {
            this.matchmmsi.state = 'success'
          }

          return true
        } else {
          this.$message.error(resp.data.message || '匹配mmsi错误')
        }
      } finally {
        // this.loadmmsiing = false;
        this.matchmmsi.isloading = false
      }
    },

    selectMatchmmsi() {
      this.form.mmsi = this.matchmmsi.mmsi
      this.matchmmsi.mmsi = null
      this.matchmmsi.state = 'success'
    },

    async save() {
      const params = {}
      keys.forEach(k => (params[k] = this.form[k]))

      try {
        if (!this.form.btm || !this.form.etm) {
          return this.$message.error('开始时间、结束时间不能为空')
        }

        if (this.form.btm >= this.form.etm) {
          return this.$message.error('开始时间需要小于结束时间')
        }

        await this.$confirm('确定保存?')

        this.saving = true
        params.id = this.info.id
        params.mmsi = params.mmsi || 0
        const resp = await this.$api.post(
          '/trace/aiseventops/updatesubscription',
          params,
          { baseURL: '/' }
        )

        if (resp.data.status === 1) {
          this.$message.success('保存成功')
          this.$emit('saveSuccessful')
        } else {
          this.$message.error(resp.data.message || '保存失败')
        }
      } finally {
        this.saving = false
      }
    },

    onchangebtm() {
      if (!this.form.btm) {
        this.form.btm = this.info.btm
      }
    },

    async loadRecordlist() {
      const { mmsi, btm, etm } = this.form

      if (!mmsi) {
        return this.$message.error('mmsi 不能为空')
      }

      if (!btm || !etm) {
        return this.$message.error('时间不能为空')
      }

      if (mmsi && btm && etm) {
        let btm0 = dayjs(btm, 'YYYY-MM-DD hh:mm:ss')
            .add(-1, 'month')
            .format('YYYY-MM-DD hh:mm:ss'),
          etm0 = dayjs(etm, 'YYYY-MM-DD hh:mm:ss')
            .add(1, 'month')
            .format('YYYY-MM-DD hh:mm:ss')

        // 查询当前记录

        this.loadrecording = true
        this.isInCurrentVoyage = 0
        this.form.recordlist = []

        try {
          let [resp0, resp1] = await Promise.all([
            this.$api.post(
              '/trace/aiseventops/listCurrentVoyage',
              { mmsi },
              { baseURL: '/' }
            ),
            this.$api.get('/trace/aiseventops/queryHistoryVoyage', {
              params: {
                mmsi,
                btm: btm0,
                etm: etm0,
              },
              baseURL: '/',
            }),
          ])

          const recordlist = []

          if (resp0.data.status === 1) {
            const content = (resp0.data.content.list || [])[0] || {}

            this.isInCurrentVoyage = content.mmsi ? -1 : mmsi

            console.log('this.isInCurrentVoyage', this.isInCurrentVoyage)

            if (content.arrivalPortName) {
              if (content.atPortArrival && content.atBerthArrival) {
                const time = dayjs(content.atPortArrival, 'YYYY-MM-DD hh:mm:ss')
                if (time.isBefore(etm0) && time.isAfter(btm0)) {
                  recordlist.push({
                    ata: content.atPortArrival,
                    portEn: content.arrivalPortName,
                    atbA: content.atBerthArrival,
                    atbD: content.atBerthDeparture,
                    portCode0: content.portCode0,
                    type: 'current',
                  })
                }
              }
            }
          }

          if (resp1.data.status === 1) {
            ;(resp1.data.content || []).forEach(item => {
              recordlist.push({
                ata: item.ata,
                portEn: item.portEnName,
                portCn: item.portCnName,
                atbA: item.atBerthA,
                atbD: item.atBerthD,
                atd: item.atd,
                portCode: item.portCode,
                portCode0: item.portCode0,
                type: 'history',
              })
            })
          }

          this.form.recordlist = recordlist
        } finally {
          this.loadrecording = false
        }
      }
    },

    relativeTime(time) {
      if (time) {
        return dayjs(time, 'YYYY-MM-DD hh:mm:ss').fromNow()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.aisevent-look {
  border: none;

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }

  .warn {
    color: #ff9900;
    cursor: pointer;
    margin-left: 5px;
  }

  .relative-time {
    font-size: 12px;
    color: #999;
    line-height: 12px;
  }

  .mmsi-area {
    display: flex;
    flex-direction: row;
    align-items: center;

    .mmsi-input {
      flex-grow: 1;
    }

    .match-result {
      margin-left: 6px;
      font-size: 1.5em;

      &.match-result-loading {
        font-size: 1em;
      }

      &.match-result-success {
        color: #67c23a;
      }

      &.match-result-error {
        color: #f56c6c;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.modify-item {
  font-size: 13px;
  line-height: 2;

  .modify-title {
    font-weight: bold;
  }

  .modify-text {
    margin: 0 3px;
  }

  .modify-source,
  .modify-target {
    font-weight: bold;
  }

  .modify-target {
    color: #a84c00;
  }
}
</style>
